import Vue from "vue";
import VueRouter from "vue-router";
import SideMap from "./sideMap";
import { clearBrowserData } from "@/utils/common";
import { localStorage } from "@/utils/localStorage";
import { MessageBox } from "element-ui";
import i18nLocale from "@/helpers/locale";

Vue.use(VueRouter);

let routes = [];

SideMap.forEach(rootPage => {
  if (rootPage.path) {
    routes.push(rootPage);
  }

  if (rootPage.item && rootPage.item.length > 0) {
    rootPage.item.forEach(page => {
      if (page.path) {
        routes.push(page);
      }
    });
  }
});

routes.push({
  path: "/*",
  component: () => import(/* webpackChunkName: "NotFound" */ "@/pages/NotFound/NotFound"),
});

routes = routes.filter(route => {
  if (route.isAuth !== false) {
    route.meta = {
      requireAuth: true,
    };
    return route;
  }

  return route;
});

const router = new VueRouter({
  mode: "history",
  routes
});

const promptFn = (text, callback = () => {}) => {
  MessageBox.alert(text, {
    showClose: false,
    callback,
  });
};

const handleTokenExpired = (to, from, next) => {
  clearBrowserData();

  promptFn(i18nLocale("err.authInvalid"), () => {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  });
};

router.beforeEach((to, from, next) => {
  localStorage.remove("requestQueue");

  if (to.meta.requireAuth) {
    let isLogin = localStorage.get("token");

    if (isLogin) {
      next();
    } else {
      handleTokenExpired(to, from, next);
    }
  } else {
    next();
  }
});

router.onError(error => {
  console.log('Router error! ', error);
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
